
<template>
  <transition name="fade">
    <div v-show="value || true" @click="$emit('click')" class="modal-container" :style="{'z-index': z_index}"></div>
  </transition>
</template>
<script>
export default {
  props: {
    z_index: {
      default: 100
    },
    value: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="less" scoped>
.modal-container{
  background: rgba(34, 34, 34, 0.7);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.fade-enter-active, .fade-leave-active{
  transition: all .25s ease-in-out;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>
